"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestDateValue = exports.getClosestDateValue = exports.getClosestDate = exports.predictEOY = void 0;
const simple_statistics_1 = require("simple-statistics");
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const getDataWithCutoffDate = (data, newestMonths) => {
    if (newestMonths === undefined || !data.length) {
        return data;
    }
    const dates = data.map((point) => point.date);
    const lastDate = dates[1];
    const dateCutoff = (0, date_fns_1.subMonths)(lastDate, newestMonths);
    const filteredData = data.filter((d) => d.date > dateCutoff);
    if (filteredData.length < 3) {
        // Ensure there is enough to work with
        return data;
    }
    return filteredData;
};
const predictEOY = (data, newestMonths) => {
    if (!data.length) {
        return undefined;
    }
    const dataWithCutoff = getDataWithCutoffDate(data, newestMonths);
    if (!dataWithCutoff.length) {
        return undefined;
    }
    const firstDateMS = dataWithCutoff[0].date.getTime();
    const regressionValues = dataWithCutoff
        .map((point) => [point.date.getTime() - firstDateMS, point.value])
        .filter((d) => d[1] !== undefined);
    const regression = (0, simple_statistics_1.linearRegression)(regressionValues);
    const regressionLine = (0, simple_statistics_1.linearRegressionLine)(regression);
    const predictionYear = dataWithCutoff[dataWithCutoff.length - 1].date.getFullYear();
    const predictionEOYDate = new Date(predictionYear, 11, 31);
    const prediction = regressionLine(predictionEOYDate.getTime() - firstDateMS);
    return {
        regression,
        regressionLine,
        predictionEOY: { date: predictionEOYDate, value: prediction },
    };
};
exports.predictEOY = predictEOY;
const getClosestDate = (dates, targetDate) => (0, lodash_1.minBy)(dates, (date) => Math.abs(date.getTime() - targetDate.getTime()));
exports.getClosestDate = getClosestDate;
const getClosestDateValue = (values, targetDate) => {
    const closest = (0, lodash_1.minBy)(values, (dv) => Math.abs(dv.date.getTime() - targetDate.getTime()));
    return closest;
};
exports.getClosestDateValue = getClosestDateValue;
const getLatestDateValue = (values, targetDate) => {
    const closest = (0, lodash_1.chain)(values)
        .filter((dv) => dv.date.getTime() - targetDate.getTime() <= 0)
        .maxBy((dv) => dv.date.getTime())
        .valueOf();
    return closest;
};
exports.getLatestDateValue = getLatestDateValue;
